<template>
  <div class="import-members" xmlns:v-on="http://www.w3.org/1999/xhtml">
    <c-import-base
      :descriptionLines="descriptionLines"
      :importFileService="membershipService"
      :csvProperties="csvProperties"
      :pageTitle="capitalize(`${$t('message.memberships')}`)"
      :importSectionTitle="`${$t('ctx.import.customers__title')}`"
      :uploadButtonLabel="`${$t('ctx.import.customers__description')}`"
      help-link="https://support.invivodigitalfactory.com/hc/fr/articles/15890213940124-Contrat-d-interface-du-flux-MEMBER-DATA-FLOW"
      @afterLoading="afterMembershipImport"
    >
      <c-import-information
        :title="`${$t('ctx.import.customers__informations')}`"
        :nbResultText="`${$t('ctx.import.customers__count')}:`"
        :exportText="`${$t('ctx.import.customers__export-action')}`"
        :importInformation="importInformation"
        :downloadCSV="downloadCSV"
      ></c-import-information>
    </c-import-base>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { CImportBase, CImportInformation } from '@invivodf/common/src/contexts/parameters'
import { capitalize } from 'lodash'
import { cooperativeService, membershipService } from '../../services'

const csvFileProperties = {
  name: 'memberships.csv',
  full_path: '/assets/csv/memberships.csv',
}
export default {
  name: 'CImportMembers',
  components: {
    CImportBase,
    CImportInformation,
  },
  data() {
    return {
      csvProperties: csvFileProperties,
      membershipService,
    }
  },
  computed: {
    ...mapGetters(['membershipImportInformation', 'cooperativeId', 'cooperative']),
    importInformation() {
      const { membershipImportInformation: { membershipCount, lastMembershipsImportAt } = {} } = this
      return { count: membershipCount, lastImportAt: lastMembershipsImportAt }
    },
  },
  methods: {
    capitalize,
    afterMembershipImport() {
      this.$store.dispatch('setMembershipImportInformation')
    },
    downloadCSV() {
      return cooperativeService.downloadMemberships(this.cooperativeId, this.cooperative.name)
    },
  },
}
</script>
